import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { dialogContentInformations } from "../../interfaces/dialogInformations";
import { CustomButton } from "../CustomButton/CustomButton";
import * as Styles from "./CustomDialog.styles";

interface CustomDialogProps {
  open: boolean;
  contentInformations: dialogContentInformations;
  onClose: () => void;
  onConfirm: () => void;
  onAfterClose?: () => void;
}

export default function CustomDialog({ open, contentInformations, onClose, onConfirm, onAfterClose }: CustomDialogProps) {
  const id = "custom-dialog-title";

  return (
    <Styles.CustomDialog
      open={open}
      onClose={onClose}
      aria-labelledby={id}
      disableEnforceFocus
      disableAutoFocus
      disableRestoreFocus
      TransitionProps={{
        onExited: () => {
          if (onAfterClose) {
            onAfterClose();
          }
        },
      }}
    >
      <DialogTitle id={id}>{contentInformations.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{contentInformations.content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Styles.ActionButtonText variant="text" onClick={onClose}>
          {contentInformations.closeText}
        </Styles.ActionButtonText>
        <CustomButton
          textColor="var(--color-text-inverse)"
          backgroundColor="var(--color-error)"
          hoverBackgroundColor="var(--color-error-light)"
          onClick={onConfirm}
        >
          {contentInformations.confirmText}
        </CustomButton>
      </DialogActions>
    </Styles.CustomDialog>
  );
}
